//Информация о постах, контейнерах и дерево оргсхемы
export default {
  posts: {},
  containers: {},
  structure: [],
  tree: []
}



// WEBPACK FOOTER //
// ./src/apps/org/store/common/org/state.js